import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

interface ClientLimitResponse {
  allowed: boolean;
  unlimited: boolean;
  current_count: number;
  limit: number;
  remaining: number;
  beta_tester?: boolean;
}

export const useClientLimits = () => {
  const { data, isLoading, error, refetch } = useQuery<ClientLimitResponse>({
    queryKey: ['client-limits'],
    queryFn: async () => {
      const response = await api.get<ClientLimitResponse>('/social-limits/max-clients');
      return response.data;
    },
    staleTime: 30 * 1000, // 30 seconds
    cacheTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    canCreateClient: data?.allowed ?? true,
    isUnlimited: data?.unlimited ?? false,
    currentCount: data?.current_count ?? 0,
    maxLimit: data?.limit ?? -1,
    remaining: data?.remaining ?? -1,
    isBetaTester: data?.beta_tester ?? false,
    isLoading,
    error,
    refetch,
  };
};
